import { breakpointPixels } from '~/core/util/styledComponents';
import { isClientSide } from '../../../../../core/util/system';

const getColumnCount = (category: any) => {
  const { columnCount } = category;
  let cols;
  if (isClientSide()) {
    const { innerWidth } = window; // using inner width because of safari desktop
    if (innerWidth < breakpointPixels.sm) {
      cols = columnCount.sm;
    } else if (innerWidth < breakpointPixels.mdLg) {
      cols = columnCount.md;
    } else {
      cols = columnCount.lg;
    }
  }

  return cols;
};

export { getColumnCount };
